import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaHome } from 'react-icons/fa';

const NotFound: React.FC = () => {
  const MAIN_SITE = import.meta.env.VITE_MAIN_SITE_URL || 'https://nostrahealth.com';

  return (
    <div className="min-h-screen bg-gradient-to-br from-lightPurple via-backgroundColor to-white flex items-center justify-center px-6">
      <div className="backdrop-blur-xl bg-white/60 rounded-3xl p-12 border border-white/40 shadow-2xl text-center max-w-2xl">
        <div className="mb-8">
          <h1 className="text-9xl font-black bg-gradient-to-r from-Color via-brightColor to-accentPurple bg-clip-text text-transparent mb-4">
            404
          </h1>
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Page Not Found</h2>
          <p className="text-gray-600 text-lg mb-8">
            The documentation page you're looking for doesn't exist or has been moved.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-8 py-3 bg-gradient-to-r from-Color to-brightColor text-white rounded-full font-bold hover:shadow-2xl hover:scale-105 transition-all duration-300"
          >
            <FaArrowLeft />
            Back to Docs
          </Link>
          <a
            href={MAIN_SITE}
            className="inline-flex items-center gap-2 px-8 py-3 backdrop-blur-xl bg-white/70 text-Color border-2 border-Color rounded-full font-bold hover:bg-gradient-to-r hover:from-Color hover:to-brightColor hover:text-white hover:shadow-2xl hover:scale-105 transition-all duration-300"
          >
            <FaHome />
            NostraHealth Home
          </a>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
